// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__337V1","clinicsSelect":"TableHeading_clinicsSelect__3hvB7"};